import { miniProgram } from "@tuya-miniapp/jssdk";

type OpenSymphonicsBlogMessage = {
	type: "open-symphonics-blog";
	url: string;
};

type LogMessage = {
	type: "log-message";
	message: string;
};

type ErrorMessage = {
	type: "error";
	message: string;
};

type Message = LogMessage | ErrorMessage | OpenSymphonicsBlogMessage;

export function postMessageToMiniApp(message: Message) {
	miniProgram.postMessage({ data: message });
}
